var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoving(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {},
    display: "inline"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 53.409115,37.491756 c 2.599576,0 4.708663,2.109089 4.757713,4.757713 l 0,12.311196 -3.727692,0 0,-11.330224 0,0 0,-0.04905 c 0,-0.147143 -0.0981,-0.245243 -0.245243,-0.245243 -0.147143,0 -0.245243,0.0981 -0.245243,0.245243 l 0,30.115835 -4.414373,0 0,-16.382229 0,0 -0.784777,0 0,16.382229 -4.414374,0 0,-30.066786 0,0 0,-0.04905 c 0,-0.147143 -0.0981,-0.245243 -0.245243,-0.245243 -0.147143,0 -0.245243,0.0981 -0.245243,0.245243 l 0,11.428322 -3.727693,0 0,-12.360245 c 0,-2.599575 2.158138,-4.757713 4.757713,-4.757713 l 8.534455,0 z M 49.141888,36.95222 c -2.158138,0 -3.874839,-1.716701 -3.874839,-3.87484 0,-2.158137 1.716701,-3.874838 3.874839,-3.874838 2.158138,0 3.874838,1.716701 3.874838,3.874838 0,2.158139 -1.7167,3.87484 -3.874838,3.87484 z M 25.03125,12.65625 c -13.550305,0 -22.5,8.337221 -22.5,20.84375 0,7.33277 3.5585997,15.524753 11.71875,23 L 49.375,89.125 84.46875,56.5 c 8.16015,-7.474372 11.71875,-15.66723 11.71875,-23 0,-12.506529 -8.94314,-20.84375 -22.5,-20.84375 -12.627912,0 -16.920233,5.468826 -24.3125,13.375 -7.391331,-7.906174 -11.716775,-13.375 -24.34375,-13.375 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoving);
export default __webpack_public_path__ + "static/media/loving.794f8b4a497d917472279e1559661394.svg";
export { ForwardRef as ReactComponent };